export default __webpack_public_path__ + "static/media/OPD_CARD_BLANK_1.e8d7a1ec.png";